/* ============================================================
   Solawave V2 — blog.js (main-blog section)
   - Client-side blog tab switching (links keep working w/o JS)
   - Incremental article reveal + infinite-scroll sentinel
   Replaces the old Alpine `blog()` component.
   ============================================================ */

const root = document.querySelector('[data-blog]');

if (root) {
  const showCount = Number(root.dataset.showCount) || 10;
  const tabs = [...root.querySelectorAll('[data-tab]')];
  const panels = [...root.querySelectorAll('[data-panel]')];
  const navList = root.querySelector('[data-blog-list]');
  const sentinel = root.querySelector('[data-blog-sentinel]');
  const counts = new Map(panels.map((p) => [p, showCount]));

  const activePanel = () => panels.find((p) => !p.hidden);

  const reveal = (panel) => {
    if (!panel) return;
    const max = counts.get(panel) ?? showCount;
    panel.querySelectorAll('[data-blog-item]').forEach((item, i) => {
      item.hidden = i >= max;
    });
  };

  const slideToActiveTab = () => {
    const active = navList?.querySelector('.is-active');
    if (active && navList) {
      navList.scrollLeft += active.getBoundingClientRect().left - navList.getBoundingClientRect().left - 20;
    }
  };

  const setActive = (handle, url) => {
    tabs.forEach((tab) => {
      const on = tab.dataset.tab === handle;
      tab.classList.toggle('is-active', on);
      if (on) tab.setAttribute('aria-current', 'true');
      else tab.removeAttribute('aria-current');
    });
    panels.forEach((panel) => {
      panel.hidden = panel.dataset.panel !== handle;
    });
    const panel = activePanel();
    counts.set(panel, showCount);
    reveal(panel);
    if (url) window.history.replaceState({}, '', url);
    window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY, behavior: 'smooth' });
    slideToActiveTab();
  };

  /* Tab links: intercept and switch client-side (old theme's fake navigation) */
  tabs.forEach((tab) => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();
      if (tab.classList.contains('is-active')) return;
      setActive(tab.dataset.tab, tab.getAttribute('href'));
    });
  });

  /* Back/forward after replaceState: reload to re-sync server state (parity with old) */
  window.addEventListener('popstate', () => window.location.reload());

  /* Infinite reveal */
  if (sentinel) {
    new IntersectionObserver(
      (entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        const panel = activePanel();
        if (!panel) return;
        counts.set(panel, (counts.get(panel) ?? showCount) + showCount);
        reveal(panel);
      },
      { rootMargin: '400px 0px' }
    ).observe(sentinel);
  }

  /* Vertical wheel -> horizontal scroll on the tab strip */
  if (navList) {
    let queued = false;
    navList.addEventListener(
      'wheel',
      (e) => {
        e.preventDefault();
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          navList.scrollBy({ left: e.deltaY < 0 ? -500 : 500, behavior: 'smooth' });
        });
      },
      { passive: false }
    );
  }

  slideToActiveTab();
}